<script setup>
</script>
<template>
  <iframe
    class="w-full min-h-[90vh] mb--20 bg-gray-100"
    style="height:calc(100vh - 4rem)"
    src="https://bitcrush.org/poketools/_stardex/"
    title="StarDex"
  ></iframe>
</template>
